import React from 'react'
import iconImg from "../assets/myportal-icon.png"

const Topbar: React.FC = () => {
    return (
        <header className="w-full h-[72px] sm:h-20 flex items-center justify-center bg-app-top border-b border-white/[0.08]">
            <div className="flex items-center gap-3" aria-label="My Portal">
                <img src={iconImg} alt="" width={44} height={44} className="w-10 h-10 sm:w-11 sm:h-11 rounded-[11px]" />
                <span className="text-[19px] sm:text-[20px] font-extrabold tracking-tight text-white">My Portal</span>
            </div>
        </header>
    )
}

export default Topbar
